import * as React from 'react'

const SvgArrowDownCircleSolid = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M22.25 12.676c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75 4.365-9.75 9.75-9.75 9.75 4.365 9.75 9.75m-6.22 1.28-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72v-5.94a.75.75 0 0 1 1.5 0v5.94l1.72-1.72a.75.75 0 1 1 1.06 1.06"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgArrowDownCircleSolid
